<template>
  <v-data-table
    :titulo="titulo"
    :headers="headers"
    :items="items"
    class="elevation-1"
    :loading="loading"
    loading-text="Carregando... Aguarde"
    :search="search"
    no-results-text="Nenhum resultado encontrado"
    locale="pt-BR"
    :options.sync="gridOptions"
    @update:options="saveLocalOptions"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Pesquisa"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              :loading="loading"
              class="ml-3"
              v-on="on"
              @click="$emit('atualizaLista')"
            ><v-icon small>fa-redo-alt</v-icon>
            </v-btn>
          </template>
          <span>Atualizar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              class="mr-3"
              v-on="on"
              @click="$emit('filtrar')"
            ><v-icon small>fa-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtrar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              fab
              dark
              small
              v-on="on"
              @click="$router.push({ name: 'Novo Documento' })"
            ><v-icon small>fa-plus</v-icon>
            </v-btn>
          </template>
          <span>Novo</span>
        </v-tooltip>
      </v-toolbar>
    </template>
    <template v-slot:item.tags="{ item }">
      <div class="d-flex align-center">
        <v-tooltip
          v-for="tag of item.tags"
          :key="tag._id"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-chip
              v-on="on"
              small
              :color="tag.cor"
              class="ma-1"
            ></v-chip>
          </template>
          <span>{{ tag.descricao }}</span>
        </v-tooltip>
      </div>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip :color="statusColor(item.status)" dark>{{ item.status }}</v-chip>
    </template>
    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | formattedDate }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="$emit('editItem', item)"
      >
        fa-edit
      </v-icon>
      <v-icon
        small
        @click="$emit('deleteItem', item)"
      >
        fa-trash
      </v-icon>
    </template>
    <template v-slot:no-data>
      <span class="pr-3">Nenhum registro encontrado</span>
      <v-btn
        text
        icon
        :loading="loading"
        class="mr-3"
        @click="$emit('atualizaLista')"
      >
        <v-icon>fa-redo-alt</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    name: 'GridShared',
    data: () => ({
      search: '',
      gridOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['titulo'],
        sortDesc: [false]
      }
    }),
    props: {
      titulo: {
        type: String,
        default: 'Título'
      },
      headers: {
        type: Array,
        default: () => [
          {
            text: 'Descrição',
            align: 'start',
            value: 'descricao',
          },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'actions', sortable: false },
        ]
      },
      items: {
        type: Array,
        default: () => []
      },
      sortBy: {
        type: String,
        default: 'descricao'
      }
    },
    computed: {
      ...mapGetters(['loading']),
    },
    methods: {
      statusColor(status) {
        if (status === 'Em Progresso') return 'primary';
        else if (status === 'Solicitar Revisão') return 'warning';
        else if (status === 'Solicitar Correção') return 'error';
        else if (status === 'Cancelado') return 'secondary';
        else return 'success';
      },
      loadLocalOptions() {
        if (localStorage.getItem(`GridShared${this.titulo}Options`)) {
          this.gridOptions = JSON.parse(localStorage.getItem(`GridShared${this.titulo}Options`));
        }
      },
      saveLocalOptions(event) {
        localStorage.setItem(`GridShared${this.titulo}Options`, JSON.stringify(event));
      }
    },
    beforeMount() {
      this.loadLocalOptions();
    }
  }
</script>